import React, { useRef, useState } from "react";

import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";

import Select from "react-select";

import styles from "./EditEcommerceProduct.module.css";

import MultipleProductImages from "./EcomComponents/MultipleProductImages";

import BasicDetails from "./EcomComponents/BasicDetails";

import ProductSpecification from "./EcomComponents/ProductSpecification";

import ProductVariants from "./EcomComponents/ProductVariants";

const selectStyle = {
  control: (base, state) => ({
    ...base,

    minHeight: "40px",

    borderRadius: "12px",

    borderColor: state.isFocused ? "#0d6efd" : "#dce1ea",

    boxShadow: "none",

    fontSize: "13px",
  }),
};

const dummyOptions = [
  {
    value: "1",
    label: "Option 1",
  },

  {
    value: "2",
    label: "Option 2",
  },
];

const EditEcommerceProduct = () => {
  /* Primary Image */

  const [primaryImage, setPrimaryImage] = useState(null);

  const [imageRatio, setImageRatio] = useState(1);

  /* Product Code */

  const [productCode, setProductCode] = useState(() => {
    return `PRD-${Date.now().toString().slice(-6)}`;
  });

  /* Pricing */

  const [mrp, setMrp] = useState("");

  const [discount, setDiscount] = useState("");

  const [price, setPrice] = useState("");

  /* Refs */

  const primaryInfoRef = useRef(null);

  const multipleImagesRef = useRef(null);

  const basicDetailsRef = useRef(null);

  const specificationRef = useRef(null);

  const variantsRef = useRef(null);

  const rateRef = useRef(null);

  /* Sidebar */

  const sections = [
    {
      label: "Primary Information",
      ref: primaryInfoRef,
    },

    {
      label: "Multiple Images",
      ref: multipleImagesRef,
    },

    {
      label: "Basic Details",
      ref: basicDetailsRef,
    },

    {
      label: "Specification",
      ref: specificationRef,
    },

    {
      label: "Variants",
      ref: variantsRef,
    },
 
  ];

  /* Scroll */

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({
      behavior: "smooth",

      block: "start",
    });
  };

  /* Primary Image */

  const handlePrimaryImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);

      const img = new Image();

      img.src = imageUrl;

      img.onload = () => {
        const ratio = img.width / img.height;

        setImageRatio(ratio);

        setPrimaryImage(imageUrl);
      };
    }
  };

  /* Product Code */

  const generateProductCode = () => {
    const random = Math.floor(1000 + Math.random() * 9000);

    return `PRD-${random}`;
  };

  /* Pricing */

  const handleMrpChange = (value) => {
    setMrp(value);

    const mrpValue = parseFloat(value) || 0;

    const discountValue = parseFloat(discount) || 0;

    if (mrpValue > 0) {
      const finalPrice = mrpValue - (mrpValue * discountValue) / 100;

      setPrice(finalPrice.toFixed(2));
    }
  };

  const handleDiscountChange = (value) => {
    setDiscount(value);

    const mrpValue = parseFloat(mrp) || 0;

    const discountValue = parseFloat(value) || 0;

    if (mrpValue > 0) {
      const finalPrice = mrpValue - (mrpValue * discountValue) / 100;

      setPrice(finalPrice.toFixed(2));
    }
  };

  const handlePriceChange = (value) => {
    setPrice(value);

    const mrpValue = parseFloat(mrp) || 0;

    const finalPrice = parseFloat(value) || 0;

    if (mrpValue > 0) {
      const finalDiscount = ((mrpValue - finalPrice) / mrpValue) * 100;

      setDiscount(finalDiscount.toFixed(2));
    }
  };

  return (
    <Container fluid className="py-3">
      <Row className="g-3">
        {/* Sidebar */}

        <Col lg={2}>
          <Card className={styles.sidebarCard}>
            <Card.Body>
              <div className={styles.sidebarTitle}>Sections</div>

              <div className={styles.sectionList}>
                {sections.map((item, index) => (
                  <button
                    key={index}
                    className={styles.sectionBtn}
                    onClick={() => scrollToSection(item.ref)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>

              <Button className={styles.saveBtn}>Save Product</Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Main */}

        <Col lg={10}>
          <Card className={styles.mainCard}>
            <Card.Body>
              <div className={styles.pageTitle}>Edit Ecommerce Product</div>

              {/* Primary Information */}

              <Card className={styles.sectionCard} ref={primaryInfoRef}>
                <Card.Body>
                  <div className={styles.sectionTitle}>
                    Primary Information
                  </div>

                  <Row className="g-3">
                    {/* Image */}

                    <Col xxl={2} xl={2} lg={3} md={4}>
                      <Form.Label className={styles.label}>
                        Primary Image
                      </Form.Label>

                      <label
                        className={styles.primaryImageBox}
                        style={{
                          aspectRatio: imageRatio,
                        }}
                      >
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handlePrimaryImage}
                        />

                        {primaryImage ? (
                          <img
                            src={primaryImage}
                            alt="primary"
                            className={styles.primaryImage}
                          />
                        ) : (
                          <span>Upload</span>
                        )}
                      </label>
                    </Col>

                    {/* Content */}

                    <Col xxl={10} xl={10} lg={9} md={8}>
                      <Row className="g-2">
                        <Col xxl={3} xl={4} lg={4} md={6}>
                          <Form.Label className={styles.label}>
                            Supplier / Brand
                          </Form.Label>

                          <Select
                            styles={selectStyle}
                            options={dummyOptions}
                            placeholder="Supplier"
                          />
                        </Col>

                        <Col xxl={3} xl={4} lg={4} md={6}>
                          <Form.Label className={styles.label}>
                            Category
                          </Form.Label>

                          <Select
                            styles={selectStyle}
                            options={dummyOptions}
                            placeholder="Category"
                          />
                        </Col>

                        <Col xxl={3} xl={4} lg={4} md={6}>
                          <Form.Label className={styles.label}>
                            Subcategory
                          </Form.Label>

                          <Select
                            styles={selectStyle}
                            options={dummyOptions}
                            placeholder="Subcategory"
                          />
                        </Col>

                        <Col xxl={3} xl={3} lg={4} md={6}>
                          <Form.Label className={styles.label}>Type</Form.Label>

                          <Select
                            styles={selectStyle}
                            options={dummyOptions}
                            placeholder="Type"
                          />
                        </Col>

                        <Col xxl={3} xl={3} lg={3} md={6}>
                          <Form.Label className={styles.label}>
                            Publish Date
                          </Form.Label>

                          <Form.Control type="date" className={styles.input} />
                        </Col>

                        <Col xxl={3} xl={3} lg={3} md={6}>
                          <Form.Label className={styles.label}>
                            Status
                          </Form.Label>

                          <Form.Select className={styles.input}>
                            <option>Active</option>

                            <option>Inactive</option>
                          </Form.Select>
                        </Col>

                        <Col xxl={6} xl={3} lg={3} md={12}>
                          <Form.Label className={styles.label}>
                            Product Code
                          </Form.Label>

                          <Form.Control
                            type="text"
                            value={productCode}
                            placeholder="Product Code"
                            className={styles.input}
                            onChange={(e) => setProductCode(e.target.value)}
                          />
                        </Col>

                        <Col lg={12}>
                          <Form.Label className={styles.label}>
                            Product Title
                          </Form.Label>

                          <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Enter Product Title"
                            className={styles.textarea}
                          />
                        </Col>

                        <Col lg={4} md={4}>
                          <Form.Label className={styles.label}>MRP</Form.Label>

                          <Form.Control
                            type="number"
                            value={mrp}
                            placeholder="MRP"
                            className={styles.input}
                            onChange={(e) => handleMrpChange(e.target.value)}
                          />
                        </Col>

                        <Col lg={4} md={4}>
                          <Form.Label className={styles.label}>
                            Discount %
                          </Form.Label>

                          <Form.Control
                            type="number"
                            value={discount}
                            placeholder="Discount"
                            className={styles.input}
                            onChange={(e) =>
                              handleDiscountChange(e.target.value)
                            }
                          />
                        </Col>

                        <Col lg={4} md={4}>
                          <Form.Label className={styles.label}>
                            Final Price
                          </Form.Label>

                          <Form.Control
                            type="number"
                            value={price}
                            placeholder="Final Price"
                            className={styles.input}
                            onChange={(e) => handlePriceChange(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Multiple Images */}

              <Card className={styles.sectionCard} ref={multipleImagesRef}>
                <Card.Body>
                  <div className={styles.sectionTitle}>Multiple Images</div>

                  <MultipleProductImages />
                </Card.Body>
              </Card>

              {/* Basic Details */}

              <Card className={styles.sectionCard} ref={basicDetailsRef}>
                <Card.Body>
                  <div className={styles.sectionTitle}>Basic Details</div>

                  <BasicDetails />
                </Card.Body>
              </Card>

              {/* Specification */}

              <Card className={styles.sectionCard} ref={specificationRef}>
                <Card.Body>
                  <div className={styles.sectionTitle}>Specification</div>

                  <ProductSpecification />
                </Card.Body>
              </Card>

              {/* Variants */}

              <Card className={styles.sectionCard} ref={variantsRef}>
                <Card.Body>
                  <div className={styles.sectionTitle}>Variants</div>

                  <ProductVariants />
                </Card.Body>
              </Card>

               
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EditEcommerceProduct;